var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 230",
    style: {
      enableBackground: "new 0 0 300 230"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    d: "M282.2,33.3c-9.7,4.3-20.1,7.2-31,8.5c11.2-6.7,19.7-17.3,23.8-29.9c-10.4,6.2-22,10.7-34.3,13.1 C230.7,14.6,216.7,8,201.1,8c-29.8,0-54,24.2-54,54c0,4.2,0.5,8.4,1.4,12.3c-44.9-2.3-84.7-23.8-111.4-56.4 c-4.7,8-7.3,17.3-7.3,27.2c0,18.7,9.5,35.3,24,45c-8.9-0.3-17.2-2.7-24.5-6.8c0,0.2,0,0.5,0,0.7c0,26.2,18.6,48,43.3,53 c-4.5,1.2-9.3,1.9-14.2,1.9c-3.5,0-6.9-0.3-10.2-1c6.9,21.5,26.8,37.1,50.5,37.5c-18.5,14.5-41.8,23.1-67.1,23.1 c-4.4,0-8.7-0.3-12.9-0.8c23.9,15.3,52.3,24.3,82.8,24.3c99.4,0,153.7-82.3,153.7-153.7c0-2.3-0.1-4.7-0.2-7 C265.8,53.7,274.9,44.2,282.2,33.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.8af0f6ce536ddf999a8ee68bfcdb8c88.svg";
export { ForwardRef as ReactComponent };